import { readonly, ref } from 'vue'

const isPatientUpdated = ref(false)

export const usePatient = (): any => {
  const setUpdatePatient = (isUpdated: boolean) => {
    isPatientUpdated.value = isUpdated
  }

  return {
    isPatientUpdated: readonly(isPatientUpdated),
    setUpdatePatient,
  }
}
